import { useState } from "react";
import { api } from "../lib/api.js";
import { Mostarda } from "../components/Mostarda.js";

/**
 * Registro de peso. Uma entrada, um botão.
 *
 * O texto sobre horário não é enfeite: o TDEE adaptativo lê a TENDÊNCIA, e
 * tendência calculada sobre medidas feitas em condições diferentes vira ruído.
 * Pesar sempre igual vale mais que pesar com balança cara.
 */
export function Peso({ aoFechar }: { aoFechar: () => void }) {
  const [kg, setKg] = useState("");
  const [gordura, setGordura] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const valor = Number(kg.replace(",", "."));
  const valido = Number.isFinite(valor) && valor >= 20 && valor <= 400;

  async function salvar() {
    setOcupado(true);
    setErro(null);
    try {
      const gorduraNum = Number(gordura.replace(",", "."));
      await api.post("/log/weight", {
        kg: valor,
        ...(gordura && Number.isFinite(gorduraNum) ? { bodyFatPct: gorduraNum } : {}),
      });
      aoFechar();
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Não consegui salvar.");
      setOcupado(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-5 px-5">
      <div className="flex flex-col items-center gap-2 text-center">
        <Mostarda estado="espreitando" tamanho={110} />
        <h1 className="text-xl font-bold">Quanto deu?</h1>
        <p className="text-xs text-suave">
          Antes do café, depois do banheiro, sem roupa. Sempre do mesmo jeito — eu
          trabalho com a tendência, não com o número de hoje.
        </p>
      </div>

      <label className="flex flex-col gap-1.5">
        <span className="rotulo">Peso (kg)</span>
        <input
          className="rounded-xl2 border border-borda bg-superficie px-4 py-4 text-center text-3xl font-bold tabular-nums"
          inputMode="decimal"
          value={kg}
          onChange={(e) => setKg(e.target.value)}
          placeholder="0,0"
          autoFocus
        />
      </label>

      <label className="flex flex-col gap-1.5">
        <span className="rotulo">Gordura corporal (%) — opcional</span>
        <input
          className="rounded-xl2 border border-borda bg-superficie px-4 py-3 tabular-nums"
          inputMode="decimal"
          value={gordura}
          onChange={(e) => setGordura(e.target.value)}
          placeholder="se a balança medir"
        />
      </label>

      {erro && <p className="text-sm text-alerta">{erro}</p>}

      <div className="flex flex-col gap-2">
        <button className="botao-primario" disabled={!valido || ocupado} onClick={salvar}>
          {ocupado ? "Salvando…" : "Registrar"}
        </button>
        <button className="botao-secundario" onClick={aoFechar}>
          Agora não
        </button>
      </div>
    </main>
  );
}
